import { render, staticRenderFns } from "./FormV3.vue?vue&type=template&id=65a9c6c6"
import script from "./FormV3.vue?vue&type=script&lang=js"
export * from "./FormV3.vue?vue&type=script&lang=js"
import style0 from "./FormV3.vue?vue&type=style&index=0&id=65a9c6c6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports